import React from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@mui/material'
import { theme } from './theme'
import { AuthProvider as KeycloakAuthProvider } from 'react-oidc-context'
import { AuthProvider } from './contexts/auth'
import { oidcConfig } from './utils/keycloak.util'
import App from './App'
import { ChunkErrorBoundary } from './components/ChunkErrorBoundary'
import './styles/global.scss'

const container = document.getElementById('root')

if (container) {
  const root = createRoot(container)

  root.render(
    <React.StrictMode>
      <ChunkErrorBoundary>
        <ThemeProvider theme={theme}>
          <KeycloakAuthProvider {...oidcConfig}>
            <AuthProvider>
              <App />
            </AuthProvider>
          </KeycloakAuthProvider>
        </ThemeProvider>
      </ChunkErrorBoundary>
    </React.StrictMode>,
  )
}
